<template>
    <div class="pt-[20px] bg-[#ededed]">
        <div class="max-w-[1400px] w-full container mx-auto">
            <div class="pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]">
                <offerNavigation />
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <div class="pt-[60px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]">
            <h2 class="text-left text-2xl mb-[3%] font-medium">Offerte Suchen</h2>

            <v-form @submit.prevent="search" ref="formRef">
                <v-container fluid>
                    <FormInput
                        v-model="localNumStudents"
                        label="#SuS / Studierende"
                        required
                        @change="(e: any) => (localNumStudents = e.target.value)"
                    />

                    <FormInput
                        v-model="localNumTeachers"
                        label="#LuL / Dozierende"
                        required
                        @change="(e: any) => (localNumTeachers = e.target.value)"
                    />

                    <FormInput
                        v-model="localNumUserCorrection"
                        label="Korrektur # relevanter Nutzer"
                        @change="(e: any) => (localNumUserCorrection = e.target.value)"
                    />

                    <FormSelect
                        v-model="localSelectedSchoolType"
                        :items="SchoolType"
                        :item-value="itemValue"
                        :item-text="itemText"
                        :item-title="itemTitle"
                        label="Schultyp"
                        required
                        @update:modelValue="onChangeSchoolType"
                        @change="(e: any) => (localSelectedSchoolType = e.target.value)"
                    />

                    <FormSelect
                        v-model="localDetail"
                        :items="localSelectedSchoolType ? Details[localSelectedSchoolType] : []"
                        :item-value="itemValue"
                        :item-text="itemText"
                        :item-title="itemTitle"
                        label="Details"
                        required
                        @update:modelValue="filterContracts"
                        @change="(e: any) => (localDetail = e.target.value)"
                    />

                    <FormSelect
                        v-model="localCanton"
                        :items="Canton"
                        :item-value="itemValue"
                        :item-text="itemText"
                        :item-title="itemTitle"
                        label="Kanton"
                        required
                        @update:modelValue="filterContracts"
                        @change="(e: any) => (localCanton = e.target.value)"
                    />

                    <v-textarea v-model="localComments" label="Kommentar"> </v-textarea>

                    <v-radio-group class="w-fit" v-model="localContract" row>
                        <v-radio
                            v-for="contract in filteredContracts"
                            v-bind:key="contract?.UUID"
                            :label="String(contract?.LeadPortal_Name)"
                            :value="contract"
                        >
                        </v-radio>
                    </v-radio-group>

                    <v-checkbox
                        v-model="localHasBeenSent"
                        color="#db0720"
                        label="Versand Angebot erfolgt"
                    />
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal">
                    <span class="cursor-pointer" @click="showLizenzkosten = !showLizenzkosten"
                        >Lizenzkosten
                        <i
                            class="bi-chevron-down ml-[5px] text-[#db0720]"
                            v-if="showLizenzkosten"
                        ></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showLizenzkosten">
                    <FormInput
                        v-model="n_relevante_nutzer"
                        label="Anzahl relevante Nutzer"
                        @change="(e: any) => (n_relevante_nutzer = e.target.value)"
                    />

                    <template v-for="section in formFields[0]" :key="section.title">
                        <h2 class="mb-[2%] mt-5 text-xl font-normal" v-if="'title' in section">
                            {{ section.title }}
                        </h2>
                        <div class="form-section">
                            <FormInput
                                v-for="field in section.fields"
                                :key="field.label"
                                :label="field.label"
                                v-model="computedProperty(field.model).value as string"
                                :disabled="field?.disabled || false"
                                @change="
                                    (event: any) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                "
                            />
                        </div>
                    </template>
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal">
                    <span class="cursor-pointer" @click="showRabattierung = !showRabattierung"
                        >Rabattierung
                        <i
                            class="bi-chevron-down ml-[5px] text-[#db0720]"
                            v-if="showRabattierung"
                        ></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showRabattierung">
                    <template v-for="section in formFields[1]" :key="section.title">
                        <h2 class="mb-[2%] mt-5 text-xl font-normal" v-if="'title' in section">
                            {{ section.title }}
                        </h2>
                        <div class="form-section">
                            <FormInput
                                v-for="field in section.fields"
                                :key="field.label"
                                :label="field.label"
                                v-model="computedProperty(field.model).value as string"
                                :disabled="field.disabled || false"
                                @change="
                                    (event: any) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                "
                            />
                        </div>
                    </template>
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal">
                    <span class="cursor-pointer" @click="showDiverses = !showDiverses"
                        >Diverses
                        <i class="bi-chevron-down ml-[5px] text-[#db0720]" v-if="showDiverses"></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showDiverses">
                    <template v-for="section in formFields[2]" :key="section.title">
                        <h2 class="mb-[2%] mt-5 text-xl font-normal" v-if="'title' in section">
                            {{ section.title }}
                        </h2>
                        <div class="form-section">
                            <FormInput
                                v-for="field in section.fields"
                                :key="field.label"
                                :label="field.label"
                                v-model="computedProperty(field.model).value as string"
                                :disabled="field.disabled"
                                @change="
                                    (event: any) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                "
                            />
                        </div>
                    </template>
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal">
                    <span class="cursor-pointer" @click="showUnterschriften = !showUnterschriften"
                        >Unterschriften
                        <i
                            class="bi-chevron-down ml-[5px] text-[#db0720]"
                            v-if="showUnterschriften"
                        ></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showUnterschriften">
                    <v-select
                        style="width: 50%; display: inline-block"
                        class="p-[5px]"
                        v-model="signed_2"
                        :items="signaturesList"
                        item-title="name"
                        item-value="id"
                        return-object
                        single-line
                    ></v-select>

                    <v-select
                        style="width: 50%; display: inline-block"
                        class="p-[5px]"
                        v-model="signed_1"
                        :items="signaturesList"
                        item-title="name"
                        item-value="id"
                        return-object
                        single-line
                    ></v-select>
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal">
                    <span class="cursor-pointer" @click="showLanguages = !showLanguages"
                        >Sprache
                        <i class="bi-chevron-down ml-[5px] text-[#db0720]" v-if="showLanguages"></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showLanguages">
                    <v-radio-group v-model="language" inline>
                        <v-radio class="w-25" label="Deutsch" value="DE"></v-radio>
                        <v-radio class="w-25" label="Französisch" value="FR"></v-radio>
                        <v-radio class="w-25" label="Italienisch" value="IT"></v-radio>
                        <v-radio class="w-25" label="Englisch" value="EN"></v-radio>
                    </v-radio-group>
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal">
                    <span class="cursor-pointer" @click="showPDF = !showPDF"
                        >PDF bearbeiten
                        <i class="bi-chevron-down ml-[5px] text-[#db0720]" v-if="showPDF"></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showPDF">
                    <v-text-field
                        style="width: 100%; display: inline-block"
                        class="p-[5px]"
                        label="Individuelle Einleitung"
                        v-model="introduction"
                        @change="(e: any) => (introduction = e.target.value)"
                    />
                    <v-text-field
                        style="width: 100%; display: inline-block"
                        class="p-[5px]"
                        label="Individueller Leistungsumfang"
                        v-model="scope"
                        @change="(e: any) => (scope = e.target.value)"
                    />
                    <v-text-field
                        style="width: 100%; display: inline-block"
                        class="p-[5px]"
                        label="Individueller Schluss"
                        v-model="closure"
                        @change="(e: any) => (closure = e.target.value)"
                    />
                </v-container>
                <FullButton @click="search()" width="100" title="Suchen" colour="white" />
            </v-form>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed } from 'vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import offerNavigation from '@/components/SubNavigations/TheOfferNavigation.vue'
    import useOfferStore from '@/utils/useOfferStore'
    import { Canton, Details, SchoolType } from '@/constants/offers'
    import { ExtendedContract, SelectItem, Signature } from '@/model/types'
    import FormInput from '@/components/Offers/FormInput.vue'
    import FormSelect from '@/components/Offers/FormSelect.vue'
    import formFieldsJSON from '@/components/Offers/TheProposedOfferFormFields.json'

    const formFields = ref(formFieldsJSON.formFields)
    const formRef = ref(null)

    const {
        contracts,
        selectedOffer,
        proposedOffer,
        fetchOffers,
        fetchContracts,
        signaturesList,
        fetchSignaturesList,
    } = useOfferStore()

    proposedOffer.value = {}
    selectedOffer.value = {}

    async function fetchDataOnMounted() {
        await fetchSignaturesList()
        await fetchOffers()
        await fetchContracts()
    }

    fetchDataOnMounted()

    // default visibility of menus

    const showLizenzkosten = ref(true)
    const showRabattierung = ref(true)
    const showDiverses = ref(true)
    const showUnterschriften = ref(true)
    const showLanguages = ref(true)
    const language = ref(null)
    const showPDF = ref(true)

    const itemValue = (item: SelectItem) => item.key
    const itemText = (item: SelectItem) => item.value
    const itemTitle = (item: SelectItem) => item.value

    const localNumStudents = ref(selectedOffer.value?.numStudents || '')
    const localNumTeachers = ref(selectedOffer.value?.numTeachers || '')
    const localNumUserCorrection = ref(selectedOffer.value?.numUserCorrection || '')
    const localSelectedSchoolType = ref(selectedOffer.value?.schoolType || '')
    const localDetail = ref(selectedOffer.value?.detail || '')
    const localCanton = ref(selectedOffer.value?.canton || '')
    const localHasBeenSent = ref(selectedOffer.value?.hasBeenSent || false)
    const localComments = ref(selectedOffer.value?.comments || '')
    const localContract = ref(selectedOffer.value?.contract || {})
    const filteredContracts = ref<ExtendedContract[]>([])

    // custom signatures

    let signed_2 = ref<Signature>({ id: 0, name: 'Unterschrift links' })
    let signed_1 = ref<Signature>({ id: 0, name: 'Unterschrift rechts' })

    // form fields refs

    let n_relevante_nutzer = ref(proposedOffer.value?.n_relevante_nutzer || '')
    let rabatt_bisher_n_nutzer_rabattzone = ref(
        proposedOffer.value?.rabatt_bisher?.n_nutzer_rabattzone || ''
    )
    let rabatt_bisher_stufe = ref(proposedOffer.value?.rabatt_bisher?.stufe || '')
    let rabatt_bisher_betrag = ref(proposedOffer.value?.rabatt_bisher?.betrag || '')
    let rabatt_neu_n_nutzer_rabattzone = ref(
        proposedOffer.value?.rabatt_neu?.n_nutzer_rabattzone || ''
    )
    let rabatt_neu_stufe = ref(proposedOffer.value?.rabatt_neu?.stufe || '')
    let rabatt_neu_betrag = ref(proposedOffer.value?.rabatt_neu?.betrag || '')
    let einrichtungspreis_total = ref(proposedOffer.value?.einrichtungspreis?.total || '')
    let kosten_urg_preis_pro_nutzer = ref(proposedOffer.value?.kosten_urg?.preis_pro_nutzer || '')
    let kosten_urg_total = ref(proposedOffer.value?.kosten_urg?.total || '')
    let sockelbetrag_preis_pro_nutzer = ref(
        proposedOffer.value?.sockelbetrag?.preis_pro_nutzer || ''
    )
    let sockelbetrag_total = ref(proposedOffer.value?.sockelbetrag?.total || '')
    let introduction = ref(proposedOffer.value?.introduction || '')
    let scope = ref(proposedOffer.value?.scope || '')
    let closure = ref(proposedOffer.value?.closure || '')

    const computedProperty = (propPath: string) => {
        if (typeof propPath !== 'string') {
            return computed(() => '')
        }

        const pathParts = propPath.split('.')
        return computed({
            get: () => {
                let currentValue = proposedOffer.value
                for (const part of pathParts) {
                    if (currentValue === null || currentValue === undefined) {
                        return ''
                    }
                    currentValue = currentValue[part]
                }
                return currentValue
            },
            set: (newValue) => {
                let currentValue = proposedOffer.value
                for (let i = 0; i < pathParts.length - 1; i++) {
                    const part = pathParts[i]
                    if (currentValue && currentValue[part] === undefined) {
                        currentValue[part] = {}
                    }
                    if (currentValue !== null && currentValue !== undefined) {
                        currentValue = currentValue[part]
                    }
                }
                if (currentValue !== null && currentValue !== undefined) {
                    currentValue[pathParts[pathParts.length - 1]] = newValue
                }
            },
        })
    }

    rabatt_bisher_n_nutzer_rabattzone = computedProperty('rabatt_bisher.n_nutzer_rabattzone')
    rabatt_bisher_stufe = computedProperty('rabatt_bisher.stufe')
    rabatt_bisher_betrag = computedProperty('rabatt_bisher.betrag')
    rabatt_neu_n_nutzer_rabattzone = computedProperty('rabatt_neu.n_nutzer_rabattzone')
    rabatt_neu_stufe = computedProperty('rabatt_neu.stufe')
    rabatt_neu_betrag = computedProperty('rabatt_neu.betrag')
    einrichtungspreis_total = computedProperty('einrichtungspreis.total')
    kosten_urg_preis_pro_nutzer = computedProperty('kosten_urg.preis_pro_nutzer')
    kosten_urg_total = computedProperty('kosten_urg.total')
    sockelbetrag_preis_pro_nutzer = computedProperty('sockelbetrag.preis_pro_nutzer')
    sockelbetrag_total = computedProperty('sockelbetrag.total')

    const updateProposedOfferValue = (propPath: string, newValue: any) => {
        if (typeof propPath !== 'string') {
            return
        }

        const pathParts = propPath.split('.')
        let currentValue = proposedOffer.value
        for (let i = 0; i < pathParts.length - 1; i++) {
            const part = pathParts[i]
            if (!currentValue || !currentValue[part]) {
                if (currentValue && currentValue[part] === undefined) {
                    currentValue[part] = {}
                }
            }
            if (currentValue !== null && currentValue !== undefined) {
                currentValue = currentValue[part]
            }
        }
        if (currentValue !== null && currentValue !== undefined) {
            currentValue[pathParts[pathParts.length - 1]] = newValue
        }
    }

    // functions defined and used here

    function filterContracts() {
        if (!contracts.value || !Array.isArray(contracts.value)) {
            console.error('Contracts data is not available')
            return
        }

        filteredContracts.value = contracts.value.filter((contract) => {
            return contract.Typ === localDetail.value && contract[localCanton.value]
        })
    }

    function onChangeSchoolType() {
        localDetail.value = ''
        localCanton.value = ''
        filteredContracts.value = []
    }

    function search() {
        console.log("I don't work yet")
    }
</script>
